module.exports = __webpack_public_path__ + "img/finish.45d04c6d.png";